export default "__VITE_ASSET__CaD3_ry$__"